module.exports = __webpack_public_path__ + "img/introduce-4.78d2f43b.png";